import { Title } from '@app/components/core/typography/Title'
import Column from '@app/components/layout/Column'
import { useClient } from '@based/sdk/react'
import { useTranslations } from '@i18n/useLanguage'
import defaultProjectPicture from '@app/assets/defaultProjectPicture.png'
import { useLocation } from 'wouter'
import { pages } from '@app/util/links'
import { Button } from '@app/components/core/button/Button'
import { DashboardListCard } from '@app/components/blocks/card/DashboardListCard'
import { labelAddressBuilder } from '@app/util/helpers'
import { useInterestListInitiatives } from './useInterestListInitiatives'

export const InterestListInitiatives = () => {
  const translations = useTranslations().app.dashboard.followed
  const initiativePageTranslations = useTranslations().app.initiativePage
  const commonTranslations = useTranslations().app.common
  const client = useClient()
  const { initiatives: interestListInitiatives } = useInterestListInitiatives()
  const [_, navigate] = useLocation()

  const withdraw = async (initiativeId: number) => {
    await client.call('leave-initiative', {
      initiativeId: initiativeId,
    })
  }

  return (
    <Column alignItems="stretch">
      <Title.H4 style={{ marginBottom: '0' }}>
        {translations.initiatives}
      </Title.H4>
      {interestListInitiatives.map((initiative) => (
        <DashboardListCard
          key={initiative.slug}
          title={initiative.title}
          tag={translations.tabs.interestList}
          image={initiative.images?.[0]?.src ?? defaultProjectPicture}
          location={labelAddressBuilder(
            initiative.location.address,
            commonTranslations.notSpecified,
          )}
          status={initiative.phase.name}
          onClick={() => navigate(pages.initiative(initiative.slug))}
          action={
            <Button
              variant="secondary"
              size="small"
              label={initiativePageTranslations.withdrawApplication}
              onClick={(e) => {
                e.stopPropagation()
                void withdraw(initiative.id)
              }}
            />
          }
        />
      ))}
    </Column>
  )
}
